import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beforeNext", "tourKey", "stepKey", "children", "useInStepKey", "navigationCallbackPath"];
import I18n from 'I18n';
import { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
import UIButton from 'UIComponents/button/UIButton';
import TourContext from '../contexts/TourContext';
import getNextStep from '../lib/getNextStep';
import { DONE } from '../constants/TourStates';
import handleCallback from '../lib/handleCallback';
import { jsx as _jsx } from "react/jsx-runtime";
const renderDefaultText = tour => {
  if (getNextStep(tour) === DONE) {
    return I18n.text('shepherd-react.finish');
  }
  return I18n.text('shepherd-react.next');
};
const isTourStepMatched = (tourContext, stepKey) => {
  // If stepKey is empty, consider as matched
  if (!stepKey) {
    return true;
  }
  const currentStepKey = tourContext.getStep();
  return currentStepKey === stepKey;
};
const UITourNextButton = props => {
  const {
    tour
  } = useContext(TourContext);
  const {
      beforeNext = emptyFunction,
      tourKey,
      stepKey,
      children = renderDefaultText(tour),
      useInStepKey,
      navigationCallbackPath
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    getTour,
    getStep
  } = tour;
  const isHandlingClick = useRef(false);
  const handleClick = event => {
    // Skip click handler if:
    //   1. tour handler is executing
    //   2. Or current tour step are not matched with given props
    if (isHandlingClick.current || !isTourStepMatched(tour, useInStepKey)) {
      return null;
    }
    isHandlingClick.current = true;
    if (props.onClick) {
      props.onClick(event);
    }
    try {
      return handleCallback(beforeNext, () => {
        tour.next(stepKey);
        isHandlingClick.current = false;
        if (navigationCallbackPath && tour.navigationCallback) {
          tour.navigationCallback(navigationCallbackPath);
        }
      }, {
        tourKey: tourKey || getTour(),
        stepKey: stepKey || getStep()
      });
    } catch (error) {
      isHandlingClick.current = false;
      throw error;
    }
  };
  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, buttonProps, {
    onClick: handleClick,
    children: children
  }));
};
UITourNextButton.propTypes = {
  /**
   * Callback before go to next tour step
   */
  beforeNext: PropTypes.func,
  /**
   * Tour of this button lives
   */
  tourKey: PropTypes.string,
  /**
   * The step when clicking the button to jump to
   */
  stepKey: PropTypes.string,
  children: PropTypes.node,
  /**
   * The step which the button binds to and enables clicking to next step
   */
  useInStepKey: PropTypes.string
};
export default UITourNextButton;